import {
  FETCH_AWARDS,
  FETCH_AWARD,
  SEARCH_AWARDS,
  FETCHING_AWARDS,
} from '../actions/types'; 

const INITIAL_STATE = {
  city:'', 
  fetching:true,
  awards: [],
  award: null,
  offset: 0,
  limit: 10
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case FETCH_AWARDS:
      return { ...state, ...action.payload };
    case FETCH_AWARD:
      return { ...state, award: action.payload };
    
    case SEARCH_AWARDS:
      
      return { ...state, ...action.payload };
   
    case FETCHING_AWARDS:
      return { ...state, fetching: action.payload };
    default:
      return state;
  }
};
